// UserContext.tsx

import React, { createContext, useEffect, useState } from 'react';
import { Row } from '../components/Tables/types';

interface UserContextProps {
  role: string | null;
  updateUserRole: (role: string) => void;
  rows: Row[];
  updateRows: (newRows: Row[]) => void;
  schemes: string[];
  updateUserSchemes: (schemes: string[]) => void;
}

const UserContext = createContext<UserContextProps>({
  role: null,
  updateUserRole: () => {},
  rows: [],
  updateRows: () => {},
  schemes: [],
  updateUserSchemes: () => {}
});

interface UserProviderProps {
  children: React.ReactNode;
}

const UserProvider: React.FC<UserProviderProps> = ({ children }) => {

  const [userRole, setUserRole] = useState<string | null>(() => {
    return sessionStorage.getItem('userRole');
  });

  const [userSchemes, setUserSchemes] = useState<string[]>([]);
  const [rows, setRows] = useState<Row[]>([]);

  const updateUserRole = (role: string) => {
    setUserRole(role);
    sessionStorage.setItem('userRole', role);
  };

  const updateUserSchemes = (schemes: string[]) => {
    setUserSchemes(schemes);
  };

  const updateRows = (newRows: Row[]) => {
    setRows(newRows);
  };

  const contextValue: UserContextProps = {
    role: userRole,
    updateUserRole,
    rows,
    updateRows,
    schemes: userSchemes,
    updateUserSchemes
  };

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };